export const theme = {
  colors: {
    primary: "#46516D",
    secondary: "#1b212a",
  },
};

export const useTheme = () => {
  return theme;
};
